import { render } from "./CustomerForm.vue?vue&type=template&id=56ffb0fc&scoped=true"
import script from "./CustomerForm.vue?vue&type=script&lang=js"
export * from "./CustomerForm.vue?vue&type=script&lang=js"

import "./CustomerForm.vue?vue&type=style&index=0&id=56ffb0fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56ffb0fc"

export default script